import React from "react";
import { SiVisualstudiocode, SiPostman, SiHeroku, SiNetlify } from "react-icons/si";
import { IoLogoVercel } from "react-icons/io5";
import { DiGit } from "react-icons/di";
import { AiFillCodepenCircle, AiFillCodeSandboxSquare, AiFillGithub } from "react-icons/ai"
function Toolstack() {
  return (
    <div className="skillContainer">
      <div className="tech-icons">
        <AiFillGithub /><p>GitHub</p>
      </div>
      <div className="tech-icons">
        <SiVisualstudiocode /><p>VSCode</p>
      </div>
      <div className="tech-icons">
        <SiPostman /><p>Postman</p>
      </div>
      <div className="tech-icons">
        <SiHeroku /><p>Heroku</p>
      </div>
      <div className="tech-icons">
        <IoLogoVercel /><p>Vercel</p>
      </div>
      <div className="tech-icons">
        <SiNetlify /><p>Netlify</p>
      </div>

      <div className="tech-icons">
        <AiFillCodeSandboxSquare /><p>CodeSandBox</p>
      </div>
      <div className="tech-icons">
        <DiGit /><p>Git</p>
      </div>
      <div className="tech-icons">
        <AiFillCodepenCircle /><p>Codepen</p>
      </div>

      <div className="tech-icons">
        <svg stroke="currentColor" fill="currentColor" stroke-width="0" role="img" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><title></title><path d="M12.265.002a11.911 11.911 0 00-2.437.204c13.876 1.704 10.27 17.94 1.717 17.819 0 0 12.453 1.625 11.673-10.215A11.911 11.911 0 0012.265.002zM8.213.827c-.2.002-.402.008-.61.016A11.856 11.856 0 00.146 13.608C2.93-.421 18.805 4.122 17.9 12.688c0 0 2.85-12.014-9.688-11.861zm1.454 5.035C6.002 5.886.691 7.45.816 16.344a12.013 12.013 0 002.897 4.33c.052.051.108.1.162.149a12.02 12.02 0 001.137.926c.061.044.12.092.181.135a11.93 11.93 0 001.312.779c.132.068.266.13.4.193a11.854 11.854 0 001.199.486c.1.034.195.077.297.109a11.874 11.874 0 001.49.353c.153.027.307.05.461.07a12.016 12.016 0 001.578.123l.06.003c.4 0 .792-.021 1.18-.06-13.949-3.327-8.645-18.924-.114-17.68 0 0-1.469-.41-3.389-.398zm2.436 2.762a3.355 3.355 0 103.354 3.356 3.355 3.355 0 00-3.354-3.356zm-5.95 2.192S2.82 23.09 16.172 23.196a11.978 11.978 0 007.743-9.992c.033-.319.043-.644.05-.97.001-.085.013-.168.013-.255 0-.371-.023-.737-.056-1.1-3.527 13.887-19.132 8.448-17.77-.063z"></path></svg>
        <p>Replit</p>
      </div>
    </div >
  );
}

export default Toolstack;
